import React, { useEffect } from 'react';

import { useLocation, useNavigate  } from 'react-router-dom';
import { apiFetch} from "apiClient";
import { apiFetch as fetch } from "apiClient";

function Callback() {
    const location = useLocation();
    const navigate = useNavigate();  // Initialize the navigate function

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const requestToken = urlParams.get('request_token');

        if (requestToken) {
            const qs = new URLSearchParams({ request_token: requestToken }).toString();

            fetch(`/api/kite/callback?${qs}`)
                .then(async (res) => {
                    // Endpoint typically returns plain text; fall back to JSON if needed
                    let payload;
                    try { payload = await res.text(); } catch { payload = await res.json(); }

                    console.log('Login successful:', payload);

                    // Preserve your existing token extraction logic
                    const token = (String(payload).split('Access Token: ')[1] || '').trim();
                    if (token) {
                        localStorage.setItem('kite_access_token', token);
                    }

                    navigate('/profile');
                })
                .catch((error) => {
                    console.error('Error during callback:', error);
                });
        }

    }, [location]);

    return (
        <div>
            <h2>Processing login...</h2>
        </div>
    );
}

export default Callback;
